export const GET_EVALUATION_TEMPLATE_REQUEST = 'COURSE_EVALUATION_TEMPLATE_EDIT_GET_EVALUATION_TEMPLATE_REQUEST';
export const GET_EVALUATION_TEMPLATE_SUCCESS = 'COURSE_EVALUATION_TEMPLATE_EDIT_GET_EVALUATION_TEMPLATE_SUCCESS';
export const UPDATE_EVALUATION_TEMPLATE_REQUEST = 'COURSE_EVALUATION_TEMPLATE_EDIT_UPDATE_EVALUATION_TEMPLATE_REQUEST';
export const UPDATE_EVALUATION_TEMPLATE_SUCCESS = 'COURSE_EVALUATION_TEMPLATE_EDIT_UPDATE_EVALUATION_TEMPLATE_SUCCESS';
export const DISPOSE = 'COURSE_EVALUATION_TEMPLATE_EDIT_DISPOSE_STORE';
